import { createAction, createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { advanceTrainingFollowUpEndDateToHourQuota } from "./advance-training-follow-up-end-date-to-hour-quota";

const initialState: ProcessingState = { processing: "idle" };

export const resetAdvanceTrainingFollowUpEndDateToHourQuota = createAction("admin/resetAdvanceTrainingFollowUpEndDateToHourQuota");

export const advanceTrainingFollowUpEndDateToHourQuotaReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(advanceTrainingFollowUpEndDateToHourQuota.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(advanceTrainingFollowUpEndDateToHourQuota.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(advanceTrainingFollowUpEndDateToHourQuota.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetAdvanceTrainingFollowUpEndDateToHourQuota, () => {
    return initialState;
  });
});
